import { useCallback, useEffect, useMemo, useState, type ReactNode } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { getToken, setToken, UNAUTHORIZED_EVENT } from '../api/client'
import { AuthContext } from './context'
import { rolesOf } from './roles'

export function AuthProvider({ children }: { children: ReactNode }) {
  const [token, setLocal] = useState<string | null>(getToken())
  const queryClient = useQueryClient()

  const signOut = useCallback(() => {
    setToken(null)
    setLocal(null)
    queryClient.clear()
  }, [queryClient])
  const signIn = useCallback((t: string) => {
    setToken(t)
    setLocal(t)
  }, [])
  useEffect(() => {
    const h = () => setLocal(null)
    window.addEventListener(UNAUTHORIZED_EVENT, h)
    return () => window.removeEventListener(UNAUTHORIZED_EVENT, h)
  }, [])

  const value = useMemo(() => {
    const roles = rolesOf(token)
    return { authed: token !== null && roles.length > 0, roles, signIn, signOut, hasRole: (...wanted: string[]) => wanted.some((r) => roles.includes(r)) }
  }, [token, signIn, signOut])
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
